import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { useContext, useEffect } from "react";

import { LayoutsConfig, MainContext } from "../../../main/context/MainContextProvider";

export type SelectUsinaDashboardProps = {
  textFieldSx?: SxProps<Theme>
};

export default function SelectUsinaDashboardMenu(props: SelectUsinaDashboardProps) {
  const { textFieldSx } = props;

  const { selectedDashboardUsina, setSelectedDashboardUsina, clientUsinas } =
    useContext(MainContext);
  const { isMobile, layout } = useContext(MainContext);

  const usinasIds = clientUsinas?.map((usina) => usina.usinaIds.id);

  const defaultSelected = usinasIds ? usinasIds[0] : "";

  useEffect(() => {
    localStorage.setItem("usinaId", selectedDashboardUsina?.usinaIds.id || "");
  }, [selectedDashboardUsina]);

  return (
    <Autocomplete
      size="small"
      className="px-2"
      value={selectedDashboardUsina?.usinaIds.id || defaultSelected || ""}
      onChange={(_: any, newValue: string | null | undefined) => {
        setSelectedDashboardUsina(
          clientUsinas?.find((usina) => usina.usinaIds.id === newValue)
        );
      }}
      id="plant-select"
      options={usinasIds ?? []}
      getOptionLabel={(option) => {
        return (
          clientUsinas?.find((usina) => usina.usinaIds.id === option)?.name ||
          ""
        );
      }}
      sx={{ width: isMobile ? "100%" : 200 }}
      renderInput={(params) => <TextField
        sx={{
          '& .MuiInputBase-input': {
            color: layout == LayoutsConfig.LayoutTwo ? "#FFF" : undefined,
          },
          '& .MuiInputLabel-root': {
            color: layout == LayoutsConfig.LayoutTwo ? "#8F969E" : undefined,
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: layout == LayoutsConfig.LayoutTwo ? '#E9E9E9' : undefined,
          },
          ...textFieldSx
        }}
        {...params} label="Usina" />}
    />
  );
}
